import { FC } from 'react';
import { Dialog, DialogActions, DialogContent, DialogProps, DialogTitle } from '@mui/material';
// Components
import AMBGButton from '../AMBGButton/AMBGButton';
// Styles
import * as Sx from 'assets/styles/Common.style';

interface IProps extends DialogProps {
	onConfirm: () => void;
	onCancel: () => void;
	title?: string;
	loading?: boolean;
	confirmText?: string;
	cancelText?: string;
	disabled?: boolean;
}

const AMBGDialog: FC<IProps> = (props) => {
	const {
		open,
		children,
		title,
		onConfirm,
		onCancel,
		disabled,
		confirmText,
		cancelText,
		loading,
		PaperProps,
		...rest
	} = props;
	return (
		<Dialog
			open={open}
			fullWidth
			{...rest}
			onClose={onCancel}
			data-testid='dialogBox'
			PaperProps={{ sx: { ...PaperProps?.sx, borderRadius: '10px' } }}
		>
			{title && <DialogTitle sx={{ fontSize: '25px', textAlign: 'center' }}>{title}</DialogTitle>}
			<DialogContent>{children}</DialogContent>
			<DialogActions sx={{ alignSelf: 'center', padding: '0 20px 20px' }}>
				<AMBGButton
					text={cancelText || 'Cancel'}
					sx={Sx.lightPrimaryBtn}
					onClick={onCancel}
					data-testid='dialogCancelBtn'
				/>
				<AMBGButton
					text={confirmText || 'Confirm'}
					onClick={onConfirm}
					loading={loading || false}
					data-testid='dialogConfirmBtn'
					disabled={disabled || false}
				/>
			</DialogActions>
		</Dialog>
	);
};

export default AMBGDialog;
